._InstallApplicationDrawer_12fc3_1 ._form_12fc3_1 ._submitButton_12fc3_1 {
  width: 100%;
}